import axios from "axios";
import { store } from "../Redux/app/store";
import { setRefreshToken, setUser } from "../Redux/features/userSlice";

const api = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL,
});

api.interceptors.request.use(
  (config: any) => {
    const user = JSON.parse(localStorage.getItem("currentStudent") || "{}");
    const token = user?.accessToken;
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },

  (error: any) => {
    return Promise.reject(error);
  }
);

let isRefreshing = false;
let refreshSubscribers: any[] = [];

const onRrefreshed = (token: string) => {
  refreshSubscribers.map((callback) => callback(token));
};

const addRefreshSubscriber = (callback: (token: string) => void) => {
  refreshSubscribers.push(callback);
};

api.interceptors.response.use(
  (response) => {
    return response;
  },

  async (error) => {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          addRefreshSubscriber((token: string) => {
            originalRequest.headers["Authorization"] = `Bearer ${token}`;
            resolve(api(originalRequest));
          });
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      const refreshToken = JSON.parse(
        localStorage.getItem("refreshToken") || "{}"
      );

      if (!refreshToken) {
        logoutUser();
        return Promise.reject(error);
      }

      try {
        const response: any = await axios.get(
          `${process.env.REACT_APP_SERVER_URL}/Account/RefreshToken`,
          {
            params: { refreshToken },
          }
        );

        // const newToken = response.data.accessToken;
        store.dispatch(setUser(response.data.response));
        store.dispatch(setRefreshToken(response.data.refreshToken));

        api.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${response?.data?.response?.accessToken}`;
        isRefreshing = false;
        onRrefreshed(response?.data?.response?.accessToken);
        refreshSubscribers = [];

        return api(originalRequest);
      } catch (err) {
        logoutUser();
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);

const logoutUser = () => {
  localStorage.clear();
  window.location.href = "/"; // Redirect to the login page
};

export default api;
